import { Alert } from '@/components/ui/alert';
import { creatorSpaceUrl } from '@/libs/creator-space-url';
import { Link, Stack, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { isCreatorAccountError, type AuthError } from './auth-error';

/**
 * An auth error, and for an address that belongs to a creator account, the way
 * to the creator space where that account signs in.
 */
export const AuthErrorAlert = ({ error }: { error: AuthError }) => {
  const { t } = useTranslation();

  return (
    <Alert status="error" title={t('common.error')} textAlign="center">
      <Stack gap="6px" align="center">
        <Text>{error.message}</Text>
        {isCreatorAccountError(error.code) && (
          <Link
            href={creatorSpaceUrl()}
            target="_blank"
            rel="noopener noreferrer"
            fontWeight="600"
            textDecoration="underline"
          >
            {t('authPage.creatorSpaceLink')}
          </Link>
        )}
      </Stack>
    </Alert>
  );
};
